<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>支付白名单</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(v,i) in formData" :key="i">
            <el-form-item label="用户ID">
              <el-input v-model="formData[i]" style="width: 150px;" placeholder="用户ID" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:versionSet:del']" type="danger" @click="del(i)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:versionSet:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { gePayWhiteCfg, updatePayWhiteCfg } from '@/api/config/pay-white'

export default {
  name: 'PayWhite',
  data() {
    return {
      total: 0,
      options: [],
      rewardType: [],
      formData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = this.formData.join(',')
      if (data.length < 1) {
        // this.msgError('没有需要提交的数据')
        // return
      }
      console.log(data)
      updatePayWhiteCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      gePayWhiteCfg().then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push(0)
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
